// extracted by mini-css-extract-plugin
export var columnList = "_cl-0";